import LinkLadder from "./LinkLadder";

export default LinkLadder;
